import axios from "axios";
import Decimal from "decimal.js";
import React, { useEffect, useState } from "react";
import Chart from "react-google-charts";
import consts from "../consts";
import { monthMask } from "../functions/dates";
import { cnpjMask } from "../functions/mask";

function ChartsDetail({ cnpj, razao, banco, fid, agencia, conta, ano }) {
  const [grafico, setGrafico] = useState([]);
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const months = [
    `${ano}01`,
    `${ano}02`,
    `${ano}03`,
    `${ano}04`,
    `${ano}05`,
    `${ano}06`,
    `${ano}07`,
    `${ano}08`,
    `${ano}09`,
    `${ano}10`,
    `${ano}11`,
    `${ano}12`,
  ];

  useEffect(() => {
    setList([]);
    setIsLoading(true);
    months.map(async (date) => {
      const resp = await axios.get(`${consts.API_URL}/ofxDate`, {
        params: { cnpj: cnpj, date: date, acctid: conta },
      });

      await graph(resp, date);
    });
  }, [cnpj, conta, ano]);

  const graph = async (resp, date) => {
    if (resp.data.length === 0) {
      setList((old) => [
        ...old,
        {
          id: date,
          month: monthMask(date.replace(`${ano}`, "")),
          credito: 0,
          debito: 0,
          total: 0,
        },
      ]);
    } else {
      let total = new Decimal("0.00");
      let credito = new Decimal("0.00");
      let debito = new Decimal("0.00");

      await resp.data.map((item) => {
        if (item.TRNTYPE === "CREDIT" || item.TRNTYPE === "DEP") {
          credito = credito.plus(new Decimal(item.TRNAMT.trim()));
        }
        if (item.TRNTYPE === "DEBIT") {
          if (item.TRNAMT.includes("-")) {
            debito = debito.plus(
              new Decimal(item.TRNAMT.replace("-", "").trim())
            );
          } else {
            debito = debito.plus(new Decimal(`${item.TRNAMT}`.trim()));
          }
        }
        total = credito.sub(debito);
        /*O saldo bancário está em item.BALAMT
         return (total = new Decimal(item.BALAMT.trim() || 0));*/
      });

      setList((old) => {
        const existe = old.find((item) => item.id === date);
        if (existe) return old; // evita duplicidade

        return [
          ...old,
          {
            id: date,
            month: monthMask(date.replace(`${ano}`, "")),
            credito,
            debito,
            total,
          },
        ];
      });
    }
  };

  useEffect(() => {
    const array = [];
    list
      .sort(function (a, b) {
        return a.id - b.id;
      })
      .map((item) => {
        // Este bloco de código possui saída de acordo com a classe Charts (google charts)
        //com os tipos "Mês": string, "Entrada": number, "Saída": number, "Saldo": number
        /* ----------------------------------------------------------------------- */
        return array.push([
          item.month,
          Number(item.credito.toString()) || 0,
          Number(item.debito.toString()) || 0,
          Number(item.total.toString()) || 0,
        ]);
      });
    array.unshift(["Mês", "Entrada", "Saída", "Resultado"]);
    setGrafico(array);
    console.log("valor de array:", array);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, [list]);
  /* ----------------------------------------------------------------------- */

  const options = {
    title: "Fluxo bancário",
    legend: { position: "bottom" },
    colors: ["#66d45c", "#d68f6b", "#1909ed"],
    lineWidth: 3,
    pointSize: 5,
    seriesType: "bars",
    series: {
      2: { type: "line" },
    },
  };
  return (
    <>
      {isLoading ? null : (
        <div className="flex flex-col gap-3 p-5">
          <div className="flex flex-col">
            <h1 className="text-2xl font-bold">{razao}</h1>
            <div className="flex gap-2">
              <span className="font-semibold">
                Banco:{" "}
                <span className="font-normal">
                  {fid} - {banco}
                </span>{" "}
              </span>
              <span className="font-semibold">
                Agência: <span className="font-normal">{agencia}</span>
              </span>
              <span className="font-semibold">
                Conta: <span className="font-normal">{conta}</span>
              </span>
              <span className="font-semibold">
                CNPJ: <span className="font-normal">{cnpjMask(cnpj)}</span>
              </span>
            </div>
          </div>
          <Chart
            chartType="ComboChart"
            width="100%"
            height="400px"
            data={grafico}
            options={options}
          />
        </div>
      )}
    </>
  );
}

export default ChartsDetail;
